import { render } from "./Header.vue?vue&type=template&id=1a58946a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1a58946a&scoped=true&lang=scss"

import exportComponent from "/Volumes/Macintosh HD 1/Users/admin/Documents/micowell/xmai_official_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a58946a"]])

export default __exports__